<template>
  <div class="column is-one-third-fullhd is-one-third-tablet is-full-mobile" v-if="!item.isNotAvailable">
    <div :class="['card mr-5 ml-5 ', ( item.outOfStock || item.isNotAvailable || isPaymentUnavailable )? 'is-item-disabled' : '']">
      <div v-if="image" class="card-image" v-on:click="displayDiag">
        <figure class="bg-img image is-3by2" v-lazy:background-image="image">
        </figure>
      </div>
      <div class="card-content is-paddingless">
        <div class="padding-5" v-on:click="displayDiag">
          <p class="title has-text-weight-medium is-6">
            <img v-if="isNonVeg" src="/images/nonveg.svg" width="12px" height="12px">
            <img v-if="isVeg" src="/images/veg.svg" width="12px" height="12px">
            {{item.name}}
          </p>
          <p class="subtitle is-7 has-text-grey line-clamp line-clamp-2 text-elipsis">
            {{ item.description }}
          </p>
        </div>
        <footer class="level is-mobile padding-5" v-if="isValidPrice(item.price)">
          <div class="level-left" v-on:click="displayDiag">
            <div class="level-item">
              <div class="is-size-7 has-text-weight-medium" v-html="formatPrice(item.price)"></div>
            </div>
          </div>
          <div class="level-right">
            <div v-if="statusMsg" class="is-size-7 level-item">
              {{statusMsg}}
            </div>
            <div class="level-item" v-else>
              <div v-if="item.hasItemOptions || item.hasItemVariants ">
                <a
                  class="button is-primary is-outlined is-small"
                  v-on:click="displayDiag"
                >Add<span class="is-size-6">*</span></a>
              </div>
              <quantity-btn
                v-else
                label="Add"
                fieldPlaceHolder="Quantity"
                v-model="cartItem.quantity"
                btnCls="is-primary is-small is-outlined"
                class="is-pulled-right"
                v-on:quantityfieldactivated="addItem"
              ></quantity-btn>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "@/util";
import Constants from "@/util/constants";
import quantityBtn from "@/components/ux/QuantityButton";
// import Description from "@/components/ux/Description";
import { mapGetters, mapState } from 'vuex';

export default {
  name: "item",
  props: ["item"],
  components: {
    quantityBtn
  },
  data() {
    return {
      cartItemNumber: null
    };
  },
  watch: {
    cartItem: {
      handler: function(item) {
        if (item) {
          if (item.quantity === 0) {
            this.removeItem(this.cartItem.itemNumber)
            return
          }
          this.updateItem(item)
          return
        }
        this.cartItemNumber = null
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      getTag: 'catalog/getTag',
      fetchCartItem: 'cart/cartItem',
      getEntityById: 'catalog/getEntityById',
      isBizClosed: 'business/isBizClosed',
      isBizInactive: 'business/isBizInactive',
      isPaymentUnavailable: 'business/isPaymentUnavailable'
    }),
    ...mapState('business', ['features']),
    image() {
      if (this.item.imagePath) {
        return `${this.item.imagePath}/450x300`;
      }

      return null;
    },
    isNonVeg() {
      if (!this.item.tagIds) {
        return false;
      }
      return this.item.tagIds.find(tagId => this.tagName(tagId) === "Non-vegetarian");
    },
    isVeg() {
      if (!this.item.tagIds) {
        return false;
      }
      return this.item.tagIds.find(tagId => this.tagName(tagId) === "Vegetarian");
    },
    cartItem() {
      if (this.cartItemNumber) {
        return this.fetchCartItem(this.cartItemNumber)
      }
      return {}
    },
    statusMsg () {
      if (this.isBizInactive || (this.isBizClosed && !this.features.allowPreOrder)) {
        return ' '
      }
      if (this.isPaymentUnavailable) {
        return 'Unavailable'
      }
      if (this.item.outOfStock) {
        return 'Sold Out'
      }
      if (this.item.isNotAvailable) {
        return 'Not available'
        // return this.nextAvailable()
      }
      return null
    }
  },
  methods: {
    addItem() {
      this.$store.dispatch("cart/addItem", {
        itemId: this.item.mid,
        cb: cartItem => {
          this.cartItemNumber = cartItem.itemNumber;
        },
        errCb: (err) => {
          this.$emit('showcatalogerr', err)
        }
      });
    },

    updateItem(item) {
      this.$store.dispatch("cart/updateItem", item);
    },

    removeItem(itemNumber) {
      this.$store.dispatch("cart/removeItem", itemNumber);
    },

    formatPrice(number) {
      if (isNaN(number)) {
        return "";
      }
      const curr = Constants.currency[this.$store.getters["business/currency"]];

      return [curr, Util.insertDecimalPoints(number)].join(" ");
    },

    tagName(tagId) {
      if (!tagId) {
        return "";
      }
      return this.getTag(tagId).name;
    },

    displayDiag () {
      if (this.statusMsg) {
        return
      }
      if (this.cartItemNumber) {
        this.$emit('showcartitemdialog', this.cartItemNumber)
        return
      }
      if (this.item.hasItemVariants) {
        this.displayItemDiagForVariant()
        return
      }
      this.displayItemDiag()
    },

    displayItemDiag () {
      this.addItem({
        itemId: this.itemId,
        cb: cartItem => {
          this.cartItemNumber = cartItem.itemNumber;
        }
      });
      this.$emit('showcartitemdialog', this.cartItemNumber)
    },

    displayItemDiagForVariant () {
      this.$emit('showitemdialog', this.item.mid)
    },

    isValidPrice (price) {
      return Util.isValidPrice(price)
    }

    // nextAvailable () {
    //   const schedulIds = this.getEntityById('items', this.item.mid).info.schedulIds
    //   let nextSched = null
    //   let msg = 'Not available'

    //   if (Util.isEmpty(schedulIds)) {
    //     return msg
    //   }
    //   schedulIds.forEach(schedulId => {
    //     const now = new Date()
    //     const sched = this.getEntityById('itemSchedules', schedulId)
    //     let schedDate = null

    //     if (!sched) {
    //       return
    //     }
    //     sched.itemHours.businessDays.forEach(day => {
    //       day.slots.forEach(slot => {
    //         schedDate = Util.convertToDate(slot)
    //         schedDate.setDay(day.day)

    //         if (now < schedDate) {
    //           nextSched = sched
    //         }
    //       })
    //     })
    //   })
    //   msg = `Next available at ${time.hh}:${params.outletId}/soldout`
    // }
  }
};
</script>
<style lang="scss" scoped>
  .no-padding {
    padding: 0px;
  }
  .is-grid {
    display: grid;
  }
  .align-item-end {
    align-items: flex-end;
  }
  .is-item-disabled {
    filter: grayscale(1);
    opacity: 0.7;
  }
</style>
